import { Observable } from 'rxjs/Rx'
import { combineEpics } from 'redux-observable'
import { favourite } from 'store/services/favourite'
import { createFromTemplate, estimateFromTemplate } from 'store/services/delivery'
import * as authenticationDuck from 'store/ducks/authentication'
import { decorateDeliveryFavouriteEntity } from 'store/utils/deliveryFavourite'

// Actions

export const ESTIMATION_REQUEST = 'deliveryFavourite/ESTIMATION_REQUEST'
export const ESTIMATION_SUCCESS = 'deliveryFavourite/ESTIMATION_SUCCESS'
export const ESTIMATION_FAILURE = 'deliveryFavourite/ESTIMATION_FAILURE'

export const CREATION_REQUEST = 'deliveryFavourite/CREATION_REQUEST'
export const CREATION_SUCCESS = 'deliveryFavourite/CREATION_SUCCESS'
export const CREATION_FAILURE = 'deliveryFavourite/CREATION_FAILURE'

export const ESTIMATION_RESET = 'deliveryFavourite/ESTIMATION_RESET'
export const ESTIMATION_REFETCH = 'deliveryFavourite/ESTIMATION_REFETCH'
export const CREATION_RESET = 'deliveryFavourite/CREATION_RESET'
export const VALIDATE = 'deliveryFavourite/VALIDATE'

export const FETCH_REQUEST = 'deliveryFavourite/FETCH_REQUEST'
export const FETCH_SUCCESS = 'deliveryFavourite/FETCH_SUCCESS'
export const FETCH_FAILURE = 'deliveryFavourite/FETCH_FAILURE'

// Reducer
const INITIAL_STATE = {
  favourite: {},
  estimation: {
    loading: false,
    created: false,
    entity: {},
    violations: [],
  },
  creation: {
    loading: false,
    created: false,
    entity: {},
    violations: [],
  },
  freightForwarders: {
    list: [],
    loading: false,
  },
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case ESTIMATION_REQUEST:
      return {
        ...state,
        favourite: state.favourite,
        estimation: {
          ...state.estimation,
          loading: true,
          created: false,
          entity: {},
          violations: [],
        },
      }
    case ESTIMATION_SUCCESS:
      return {
        ...state,
        favourite: state.favourite,
        estimation: {
          ...state.estimation,
          loading: false,
          created: true,
          entity: action.entity,
          violations: [],
        },
      }
    case ESTIMATION_FAILURE:
      return {
        ...state,
        favourite: state.favourite,
        estimation: {
          ...state.estimation,
          loading: false,
          created: false,
          entity: {},
          violations: action.violations,
        },
      }
    case ESTIMATION_RESET:
      return {
        ...state,
        favourite: {},
        estimation: {
          ...state.estimation,
          loading: false,
          created: false,
          entity: {},
          violations: [],
        },
      }
    case ESTIMATION_REFETCH:
      return {
        ...state,
        favourite: state.favourite,
        estimation: {
          ...state.estimation,
          loading: false,
          created: false,
          violations: [],
        },
      }
    case CREATION_REQUEST:
      return {
        ...state,
        favourite: state.favourite,
        creation: {
          ...state.creation,
          loading: true,
          created: false,
          entity: {},
          violations: [],
        },
      }
    case CREATION_SUCCESS:
      return {
        ...state,
        favourite: state.favourite,
        creation: {
          ...state.creation,
          loading: false,
          created: true,
          entity: action.entity,
          violations: [],
        },
      }
    case CREATION_FAILURE:
      return {
        ...state,
        favourite: state.favourite,
        creation: {
          ...state.creation,
          loading: false,
          created: false,
          entity: {},
          violations: action.violations,
        },
      }
    case CREATION_RESET:
      return {
        ...state,
        favourite: {},
        creation: {
          ...state.creation,
          loading: false,
          created: false,
          entity: {},
          violations: [],
        },
      }
    case VALIDATE:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: false,
          created: true,
          validated: true,
          violations: [],
        },
      }

    case FETCH_REQUEST:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: true,
          created: false,
          validated: false,
          violations: [],
        },
      }

    case FETCH_SUCCESS:
      return {
        ...state,
        favourite: action.entity,
        creation: {
          ...state.creation,
          loading: false,
          created: false,
          validated: false,
          violations: [],
        },
      }

    case FETCH_FAILURE:
      return {
        ...state,
        creation: {
          ...state.creation,
          loading: false,
          created: false,
          validated: false,
          entity: {},
          violations: [],
        },
      }
    default:
      return state
  }
}

// Actions Creators

export const estimateFromFavorite = (payload) => ({
  type: ESTIMATION_REQUEST,
  payload: payload,
})

export const estimationSuccess = (entity) => ({
  type: ESTIMATION_SUCCESS,
  entity,
})

export const estimationFailure = (violations) => ({
  type: ESTIMATION_FAILURE,
  violations,
})

export const estimationReset = () => ({
  type: ESTIMATION_RESET,
})

export const backToEstimation = () => ({
  type: ESTIMATION_REFETCH,
})

export const createFromFavorite = (payload) => ({
  type: CREATION_REQUEST,
  payload: payload,
})

export const creationSuccess = (entity) => ({
  type: CREATION_SUCCESS,
  entity,
})

export const creationFailure = (violations) => ({
  type: CREATION_FAILURE,
  violations,
})

export const creationReset = () => ({
  type: CREATION_RESET,
})

export const fetchRequest = (id) => ({
  type: FETCH_REQUEST,
  id,
})

export const validate = () => ({
  type: VALIDATE,
})

export const fetchSuccess = (entity) => ({
  type: FETCH_SUCCESS,
  entity,
})

export const fetchFailure = () => ({
  type: FETCH_FAILURE,
})

// Epics
export const epic = combineEpics(estimationRequestEpic, creationRequestEpic, fetchRequestEpic)

export function estimationRequestEpic(action$) {
  return action$.ofType(ESTIMATION_REQUEST).mergeMap((action) =>
    Observable.ajax(estimateFromTemplate({ payload: action.payload }))
      .map((res) => estimationSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) => {
            return { message: e.message, input: e.propertyPath }
          })
          return Observable.of(estimationFailure(errors))
        } catch (e) {
          return Observable.of(estimationFailure())
        }
      }),
  )
}
export function creationRequestEpic(action$) {
  return action$.ofType(CREATION_REQUEST).mergeMap((action) =>
    Observable.ajax(createFromTemplate({ payload: action.payload }))
      .map((res) => creationSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) => {
            return { message: e.message, input: e.propertyPath }
          })
          return Observable.of(creationFailure(errors))
        } catch (e) {
          return Observable.of(creationFailure())
        }
      }),
  )
}

export function fetchRequestEpic(action$) {
  return action$.ofType(FETCH_REQUEST).mergeMap((action) =>
    Observable.ajax(favourite({ params: { id: action.id } }))
      .map((res) => fetchSuccess(decorateDeliveryFavouriteEntity(res.response)))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(fetchFailure())
      }),
  )
}
